/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Grid, Input, Message, SelectAutocomplete } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

// assets
import { StyledWrapperInput, StyledWrapperMessage } from '../../../assets/styles/styles';
// constants
import {
  MAX_NAME_LENGTH,
  MAX_LASTNAME_LENGTH,
  MAX_MATERNAL_LASTNAME_LENGTH,
} from '../../../../domain/constants';

const CardPersonalData = (props) => {
  const {
    firstName,
    lastName,
    maternalLastName,
    position,
    profession,
    workActivity,
    countryNationality,
    professionItems,
    positionItems,
    workActivityItems,
    countryNationalityItems,
    disabled,
    onChange,
  } = props;

  return (
    <SimpleCard
      contentHeader={<p className="simplecard__title">Datos personales</p>}
      disabled={disabled}
    >
      <Grid row className="m-0 padding-16 p-md-6">
        <StyledWrapperMessage>
          <Message
            title="Es importante que los datos que ingreses sean iguales a los de tu cédula de identidad."
            className="w-100 mt-1 mb-3"
            description=""
            type="warning"
            closer={null}
          />
        </StyledWrapperMessage>
        <Grid className="p-0 pr-md-4 mb-2" col={12} md={4}>
          <StyledWrapperInput>
            <Input
              label="Primer nombre"
              value={firstName.value || sessionStorage.getItem('first-name') || ''}
              maxLength={MAX_NAME_LENGTH}
              assistText={firstName.errors}
              onChange={(value) =>
                onChange({
                  field: 'firstName',
                  property: 'value',
                  value,
                })
              }
              error={firstName.errors.length > 0}
              autoComplete="new-password"
            />
          </StyledWrapperInput>
        </Grid>
        <Grid className="p-0 pr-md-4 mb-2" col={12} md={4}>
          <StyledWrapperInput withoutmaxlength>
            <Input
              label="Primer apellido"
              value={lastName.value || sessionStorage.getItem('last-name') || ''}
              maxLength={MAX_LASTNAME_LENGTH}
              assistText={lastName.errors}
              onChange={(value) =>
                onChange({
                  field: 'lastName',
                  property: 'value',
                  value,
                })
              }
              error={lastName.errors.length > 0}
              autoComplete="new-password"
            />
          </StyledWrapperInput>
        </Grid>
        <Grid className="p-0 mb-2" col={12} md={4}>
          <StyledWrapperInput>
            <Input
              label="Segundo apellido"
              value={maternalLastName.value || sessionStorage.getItem('maternal-last-name') || ''}
              maxLength={MAX_MATERNAL_LASTNAME_LENGTH}
              assistText={maternalLastName.errors}
              onChange={(value) =>
                onChange({
                  field: 'maternalLastName',
                  property: 'value',
                  value,
                })
              }
              error={maternalLastName.errors.length > 0}
              autoComplete="new-password"
            />
          </StyledWrapperInput>
        </Grid>
        <Grid className="p-0 pr-md-4 mb-2 position-static" col={12} md={4}>
          <SelectAutocomplete
            label="Profesión u oficio"
            className="select-autocomplete-coopeuch"
            value={{
              value: profession.value.id || sessionStorage.getItem('id-profession'),
              label: profession.value.valor || sessionStorage.getItem('valor-profession'),
            }}
            keyPar={['id', 'valor']}
            noOptionsMessage={() => 'Sin opciones'}
            placeholder=""
            onChange={(item) =>
              onChange({
                field: 'profession',
                property: 'value',
                value: item,
              })
            }
            options={professionItems}
          />
        </Grid>
        <Grid className="p-0 pr-md-4 mb-2 position-static" col={12} md={4}>
          <SelectAutocomplete
            label="Actividad laboral"
            className="select-autocomplete-coopeuch"
            value={{
              value: workActivity.value.id || sessionStorage.getItem('id-work-activity'),
              label: workActivity.value.valor || sessionStorage.getItem('valor-work-activity'),
            }}
            keyPar={['id', 'valor']}
            noOptionsMessage={() => 'Sin opciones'}
            placeholder=""
            onChange={(item) =>
              onChange({
                field: 'workActivity',
                property: 'value',
                value: item,
              })
            }
            options={workActivityItems}
          />
        </Grid>
        {position.isVisible && (
          <Grid className="p-0 mb-2 position-static" col={12} md={4}>
            <SelectAutocomplete
              label="Cargo"
              className="select-autocomplete-coopeuch"
              keyPar={['codigo', 'descripcion']}
              noOptionsMessage={() => 'Sin opciones'}
              placeholder=""
              onChange={(item) =>
                onChange({
                  field: 'position',
                  property: 'value',
                  value: item,
                })
              }
              options={positionItems}
            />
          </Grid>
        )}
        {countryNationality.isVisible && (
          <Grid
            className={`p-0 ${position.isVisible ? 'pr-md-4 mb-2' : ''} position-static`}
            col={12}
            md={4}
          >
            <SelectAutocomplete
              label="País de nacionalidad"
              className="select-autocomplete-coopeuch"
              value={{
                value:
                  countryNationality.value.codigo ||
                  sessionStorage.getItem('codigo-country-nationality'),
                label:
                  countryNationality.value.descripcion ||
                  sessionStorage.getItem('descripcion-country-nationality'),
              }}
              keyPar={['codigo', 'descripcion']}
              noOptionsMessage={() => 'Sin opciones'}
              placeholder=""
              onChange={(item) =>
                onChange({
                  field: 'countryNationality',
                  property: 'value',
                  value: item,
                })
              }
              options={countryNationalityItems}
            />
          </Grid>
        )}
      </Grid>
    </SimpleCard>
  );
};

CardPersonalData.defaultProps = {
  rut: { value: '', isValid: () => {}, errors: [] },
  firstName: { value: '', isValid: () => {}, errors: [] },
  lastName: { value: '', isValid: () => {}, errors: [] },
  maternalLastName: { value: '', isValid: () => {}, errors: [] },
  profession: { value: {}, isValid: () => {}, errors: [] },
  professionItems: [],
  disabled: false,
  onChange: () => null,
};

CardPersonalData.propTypes = {
  rut: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  firstName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  lastName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  maternalLastName: PropTypes.shape({
    value: PropTypes.string,
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  profession: PropTypes.shape({
    value: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
  }),
  professionItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CardPersonalData;
